import { ValidatorFn, AbstractControl } from '@angular/forms';
import { VALIDATION_ERROR } from '@models-global/validation-errors';

export function validatorRequiredFields(...fields: string[]): ValidatorFn {
  return (form: AbstractControl): { [key: string]: boolean } | null => {
    let hasErrors = false;
    const requiredError = { [VALIDATION_ERROR.REQUIRED]: true };

    for (const field of fields) {
      const control = form.get(field);

      if (control && !control.value && control.value !== 0) {
        hasErrors = true;
        control.setErrors(requiredError);
      }
    }

    return hasErrors ? requiredError : null;
  };
}
